module.exports = __webpack_public_path__ + "media/icons/offer-details-przyczepy@2x-40296cf9.png";